const state = {
	carry_capacity: 0,
	casting_stat: "",
	initiative: 0,
	resolve: 0,
	spell_save_DC: 0,
}

const getters = {
	get: (state) => (property) => {
		return state[property]
	},
}

const mutations = {
	set (state, payload){
		state[payload.property] = payload.value
	},
	setMisc (state, items) {
		for(const item in items){
			state[item] = items[item]
		}
	}
}

const actions = {
	loadCharacter ({ commit }, character) {
		commit('setMisc', {
			carry_capacity: character.Misc.CarryCapacity,
			casting_stat: character.Misc.CastingStat,
			initiative: character.Misc.Initiative,
			resolve: character.Misc.Resolve,
			spell_save_DC: character.Misc.SpellSaveDCMod,
		})
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}